import zhCN from 'view-design/dist/locale/zh-CN' // 简体中文
import enUS from 'view-design/dist/locale/en-US' // 英文
import esES from 'view-design/dist/locale/es-ES' // 西班牙语
import plPL from 'view-design/dist/locale/pl-PL' // 波兰语
import zhTW from 'view-design/dist/locale/zh-TW' // 繁体中文
import ptPT from 'view-design/dist/locale/pt-PT' // 葡萄牙语
// import trTR from 'iview/dist/locale/tr-TR' // 土耳其语
// import thTH from 'iview/dist/locale/th-TH' // 泰语
// import ruRU from 'iview/dist/locale/ru-RU' // 俄语
// import zhUG from 'iview/dist/locale/zh-UG' // 维吾尔语
// import jaJP from 'iview/dist/locale/ja-JP' // 日语
// import frFR from 'iview/dist/locale/fr-FR' // 法语
// import deDE from 'iview/dist/locale/de-DE' // 德语
// import ptBR from 'iview/dist/locale/pt-BR' // 巴西葡萄牙语
// import koKR from 'iview/dist/locale/ko-KR' // 韩语
// import viVN from 'iview/dist/locale/vi-VN' // 越南语
// import svSE from 'iview/dist/locale/sv-SE' // 瑞典语
// import idID from 'iview/dist/locale/id-ID' // 印尼语
// import ukUA from 'iview/dist/locale/uk-UA' // 乌克兰语
// import itIT from 'iview/dist/locale/it-IT' // 意大利语
// import hiIN from 'iview/dist/locale/hi-IN' // 印地语
// import faIR from 'iview/dist/locale/fa-IR' // 波斯语
// import roRO from 'iview/dist/locale/ro-RO' // 罗马尼亚语
// import elGR from 'iview/dist/locale/el-GR' // 希腊语
// import nlNL from 'iview/dist/locale/nl-NL' // 荷兰语
// import csCZ from 'iview/dist/locale/cs-CZ' // 捷克语
// import mnMN from 'iview/dist/locale/mn-MN' // 蒙古语
// import mnTR from 'iview/dist/locale/mn-TR' // 传统蒙古语
// import fiFI from 'iview/dist/locale/fi-FI' // 芬兰语
// import arSA from 'iview/dist/locale/ar-SA' // 阿拉伯语
// import arEG from 'iview/dist/locale/ar-EG' // 阿拉伯语-埃及
// import daDK from 'iview/dist/locale/da-DK' // 丹麦语
// import nbNO from 'iview/dist/locale/nb-NO' // 挪威语

export default {
  zh_CN: zhCN,
  en_US: enUS,
  es_ES: esES,
  pl_PL: plPL,
  zh_TW: zhTW,
  pt_PT: ptPT
}


// WEBPACK FOOTER //
// ./src/common/lang/iviewLangs.js